// import React, { useEffect, useState } from 'react';
// import {
//   Typography,
//   Button,
//   Row,
//   Col,
//   message,
//   Card,
//   Spin,
//   Modal,
//   Progress,
//   Space,
//   Divider,
//   Tooltip,
//   Empty
// } from 'antd';
// import SidebarLayout from './SidebarLayout';
// import { useHistory } from "react-router-dom";
// import { routes } from '../../routes/Routes';
// import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from '../../constants/constants';
// import _BankerService from '../../modules/BankerService';
// import {
//   RightOutlined,
//   DeleteOutlined,
//   ExclamationCircleOutlined,
//   ApartmentOutlined,
//   QuestionCircleOutlined,
//   DollarOutlined
// } from "@ant-design/icons";
// import { Pie } from "@ant-design/plots";
// import DonutChart from '../../components/DonutChart';
// const { Title, Text } = Typography;
// const { confirm } = Modal;

// const Sponsors = () => {
//   const history = useHistory();
//   const [sponserData, setSponserData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     getSponserListByBankerId(localStorage.getItem("BankerId"))
//   }, []);

//   const getSponserListByBankerId = async () => {
//     try {
//       setLoading(true);

//       const res = await _BankerService.getSponserListByBankerId(localStorage.getItem("BankerId"));

//       if (res.data.IsSuccess) {
//         setLoading(false);
//         setSponserData(res?.data?.Obj?.List);
//       } else {
//         setLoading(false);
//         message.error(res.data.Message || COMMON_ERROR_MSG);
//       }
//     } catch (error) {
//       setLoading(false);
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onFirmsAddClick = () => {
//     history.push({ pathname: routes.addEditSponsers.path });
//   }


//   const onEditSponserClick = (dataObj) => {
//     history.push({
//       pathname: routes.addEditSponsers.path,
//       state: { sponserId: dataObj.Id },
//     });
//   }

//   // const onDeleteSponser = (dataObj) => {
//   //   confirm({
//   //     title: `Are you sure, want to delete this Firm/Agency (${dataObj.CompanyName})?`,
//   //     icon: <ExclamationCircleOutlined />,
//   //     okText: <span id="yesBtn">Yes</span>,
//   //     cancelText: <span id="noBtn">No</span>,
//   //     okType: "primary",
//   //     onOk() {
//   //       deleteSponser(dataObj.Id);
//   //     }
//   //   });
//   // };

//   // const deleteSponser = async (objId) => {
//   //   setLoading(true);
//   //   try {
//   //     const res = await _BankerService.deleteSponserBySponserId(objId);
//   //     if (res.data.IsSuccess) {
//   //       message.success(RECORD_DELETED_MSG);
//   //       getSponserListByBankerId(localStorage.getItem("BankerId"));
//   //     } else {
//   //       message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
//   //       setLoading(false);
//   //     }
//   //   } catch (e) {
//   //     console.log(e);
//   //     setLoading(false);
//   //   }
//   // };

//   return (
//     <Spin spinning={loading}>
//       <SidebarLayout>
//         <div className='baseAlign mb20'>
//           <Title level={3}>Loan Program Dashboard   </Title>
//           <Button
//             type="primary"
//             className='ml20'
//             onClick={onFirmsAddClick}
//           >
//             Add New Loan Program
//           </Button>
//         </div>

//         <Row gutter={[16, 16]}>
//           {sponserData && sponserData.map((dataObj, idx) => (
//             <Col
//               className="gutter-row"
//               xs={{ span: 24 }}
//               sm={{ span: 12 }}
//               md={{ span: 12 }}
//               lg={{ span: 12 }}
//               xl={{ span: 8 }}
//               xxl={{ span: 8 }}
//             >
//               <Card
//                 style={{
//                   borderRadius: "16px",
//                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
//                 }}
//                 className="mb30"
//                 bodyStyle={{ padding: 24 }}
//                 title={
//                   <Row justify="space-between" align="middle" style={{ width: "100%", flexWrap: "nowrap" }}>
//                     <Tooltip title={dataObj.CompanyName}>
//                       <span
//                         className="f18B"
//                         style={{
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                           maxWidth: 180, // tweak width to fit your layout
//                           display: "inline-block",
//                         }}
//                       >
//                         {dataObj.CompanyName}
//                       </span>
//                     </Tooltip>

//                     <Button
//                       type="link"
//                       style={{
//                         padding: "0 8px",
//                         whiteSpace: "nowrap", // prevent wrapping
//                       }}
//                       className='viewBtn'
//                       onClick={() => onEditSponserClick(dataObj)}
//                     >
//                       View Details
//                       <RightOutlined style={{ marginLeft: 5 }} />
//                     </Button>
//                   </Row>

//                 }

//               >

//                 <Row justify="space-around" align="middle">
//                   {/* Left - Donut chart */}
//                   <Col>
//                     <Row
//                       className="iconFont"
//                       align="middle"
//                       justify="center"
//                       style={{ marginBottom: 16 }}
//                     >
//                       <div style={{ display: 'inline-flex', alignItems: 'center' }}>
//                         <Text strong className="ant-card-head-title" style={{ fontSize: 16, margin: 0 }}>
//                           Limit Usage
//                         </Text>
//                         <Tooltip title="What is Limit Usage?">
//                           <span>
//                             <QuestionCircleOutlined className="ml10" style={{ fontSize: 16, marginLeft: 8 }} />
//                           </span>
//                         </Tooltip>
//                       </div>
//                     </Row>


//                     <div className='aligntext'>

//                       <DonutChart data={[
//                         { type: 'Remaining', value: Number(dataObj.Remaining) },
//                         { type: 'Utilized', value: Number(dataObj.Utilized) },

//                       ]}
//                         title="Budget"
//                       />
//                     </div>
//                   </Col>

//                   {/* Right - Active Loans */}
//                   <Col className='mt20 centerAlign'>
//                     <Space direction="vertical" size={8}>
//                       <Title
//                         level={5}
//                         style={{
//                           fontWeight: 600,
//                           fontSize: 16,
//                           marginBottom: 0,
//                         }}
//                       >
//                         <DollarOutlined /> Active Loan Programs
//                       </Title>
//                       <Text style={{ fontSize: 14 }}>
//                         In Progress: <strong>{dataObj.Inprogressed || "0"}</strong>
//                       </Text>
//                       <Text style={{ fontSize: 14 }}>
//                         Approved: <strong>{dataObj.Approved || "0"}</strong>
//                       </Text>
//                     </Space>
//                   </Col>
//                 </Row>
//               </Card>
//             </Col>

//           ))}
//         </Row>

//         {sponserData.length === 0 && (
//           <div style={{ textAlign: "center", marginTop: 20 }}>
//             <Empty
//               image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
//               styles={{ image: { height: 60 } }}
//               description={
//                 <Typography.Text>
//                   No Loan Programs created yet
//                 </Typography.Text>
//               }
//             />
//           </div>
//         )}
//       </SidebarLayout>

//     </Spin>
//   );
// };

// export default Sponsors;


import React, { useEffect, useState } from "react";
import {Typography,Button,Row,Col,Card,Progress,Spin,Empty,message,Pagination,Collapse} from "antd";
import { RightOutlined, PlusOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { COMMON_ERROR_MSG, RECORD_DELETED_MSG } from '../../constants/constants';
import DonutChart from '../../components/DonutChart';

import SidebarLayout from "./SidebarLayout";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import ButtonComponent from "../../components/Button/Button";
import _commonService from "../../modules/commonService";

import "./Sponsor.scss";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const Sponsors = () => {
  const history = useHistory();
  const [sponserData, setSponserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [expandedFirmKeys, setExpandedFirmKeys] = useState([]);

  useEffect(() => {
    getSponserListByBankerId(pageIndex, pageSize);
  }, []);

  const getSponserListByBankerId = async (page = pageIndex, size = pageSize) => {
    try {
      setLoading(true);

      const res = await _BankerService.getFirmCreditFacilityListByBankerId(
        localStorage.getItem("BankerId"),
        null, null,
        page,
        size
      );

      if (res.data.IsSuccess) {
        setSponserData(res?.data?.Obj?.List || []);
        setTotalCount(res?.data?.Obj?.TotalRecords || 0);
      } else {
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const toggleFirmBreakdown = (key) => {
    setExpandedFirmKeys((prevKeys) =>
      prevKeys.includes(key) ? prevKeys.filter((k) => k !== key) : [...prevKeys, key]
    );
  };

  const onViewDetailsClick = (item) => {
    if (!item.FirmId) {
      history.push({
        pathname: routes.addEditSponsers.path,
        state: { sponserId: item.SponserId },
      });
      return;
    }

    history.push({
      pathname: routes.facilityDetails.path,
      state: { firmId: item.FirmId, companyName: item.CompanyName },
    });
  };

  const handlePageChange = (page, size) => {
    setPageIndex(page);
    setPageSize(size);
    getSponserListByBankerId(page, size);
  };

  const onFirmsAddClick = () => {
    history.push({ pathname: routes.addEditSponsers.path });
  }


  const onEditSponserClick = (dataObj) => {
    history.push({
      pathname: routes.addEditSponsers.path,
      state: { sponserId: dataObj.Id },
    });
  }



  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <div className="sponsor-page-container">
          {/* HEADER */}
          <Row gutter={[8, 8]} className="dashboard-header">
            <Title level={3} className="page-title">
              Credit Facility Dashboard
            </Title>

            <Button
              icon={<PlusOutlined />}
              className="add-btn"
              onClick={() => history.push(routes.addEditSponsers.path)}
            >
              Add New Credit Facility
            </Button>
          </Row>

          {/* CARDS */}
          <Row gutter={[16, 16]}>
            {sponserData.map((item, i) => {
              const percent =
                item.TotalProgrameSize > 0
                  ? Math.round((item.Utilized / item.TotalProgrameSize) * 100)
                  : 0;
              const firmKey = item.FirmId || `legacy-${item.SponserId}`;

              return (
                <Col key={i} xs={24} sm={12} lg={8}>
                  <Card bordered={false} className="card-section loan-card">
                    {/* TITLE */}
                    <div className="loan-title">{item.CompanyName}</div>
                    <div className="loan-status">Active</div>

                    {/* UTILIZATION */}
                    {/* <div className="section">

                    <div className="utilization-header">
                      <Text className="label">Utilization</Text>
                      <Text className="percent-text">{percent}%</Text>
                    </div>

                    <Progress
                      percent={percent}
                      showInfo={false}
                      strokeColor="#5FB3A2"
                      trailColor="#2A2A2A"
                    />
                  </div> */}

                    {/* LIMIT USAGE SECTION */}
                    <Row justify="space-around" align="middle" className="limit-usage-section">

                      {/* Left - Donut */}
                      <Col>
                        <Row align="middle" justify="center" style={{ marginBottom: 12 }}>
                          <div style={{ display: "inline-flex", alignItems: "center" }}>
                            <Text strong style={{ fontSize: 15, margin: 0 }}>
                              Limit Usage
                            </Text>
                          </div>
                        </Row>

                        {/* <DonutChart
                          data={[
                            { type: "Remaining", value: Number(item.Remaining) || 0 },
                            { type: "Utilized", value: Number(item.Utilized) || 0 },
                          ]}
                          title=""
                        /> */}

                        <Col flex="none">
                          <div className="w250">
                            <DonutChart
                              data={[
                                { type: "Remaining", value: Number(item.Remaining) || 0 },
                                { type: "Utilized", value: Number(item.Utilized) || 0 },
                              ]}
                              title=""
                            />
                          </div>
                        </Col>
                      </Col>

                      {/* Right - Active Loans */}
                      {/* <Col>
                        <div style={{ textAlign: "left" }}>
                          <Title level={5} style={{ fontSize: 15, marginBottom: 8 }}>
                            Active Loans
                          </Title>

                          <Text>
                            In Progress: <strong>{item.Inprogressed || 0}</strong>
                          </Text>
                          <br />
                          <Text>
                            Approved: <strong>{item.Approved || 0}</strong>
                          </Text>
                        </div>
                      </Col> */}

                    </Row>

                    {/* VALUES */}
                    <div className="stats">
                      <div>
                        <span className="stats-label">Total Limit</span>
                        <span className="stats-value">${`${_commonService.formatNumberWithCommas(item.TotalProgrameSize) || "N/A"}`}</span>
                      </div>
                      <div>
                        <span className="stats-label">Utilized</span>
                        <span className="stats-value">${`${_commonService.formatNumberWithCommas(item.Utilized) || "N/A"}`}</span>
                      </div>
                      <div>
                        <span className="stats-label">Remaining</span>
                        <span className="stats-value">${`${_commonService.formatNumberWithCommas(item.Remaining) || "N/A"}`}</span>
                      </div>
                      {/* <div>
                        <span className="stats-label">Active Loans</span>
                        <span className="stats-value">{`${_commonService.formatNumberWithCommas(item.Inprogressed) || "N/A"}`}</span>
                      </div> */}
                    </div>

                    {/* CREDIT FACILITY TYPE BREAKDOWN */}
                    {item.Breakdown && item.Breakdown.length > 0 && (
                      <Collapse
                        className="collapseHeaderColor card-section firm-breakdown-collapse"
                        activeKey={expandedFirmKeys.includes(firmKey) ? ["1"] : []}
                        expandIcon={({ isActive }) => (
                          <span
                            onClick={() => toggleFirmBreakdown(firmKey)}
                            style={{ cursor: "pointer" }}
                          >
                            {isActive ? <UpOutlined /> : <DownOutlined />}
                          </span>
                        )}
                        expandIconPlacement="end"
                      >
                        <Panel
                          key="1"
                          showArrow={true}
                          header={
                            <div
                              onClick={() => toggleFirmBreakdown(firmKey)}
                              style={{ cursor: "pointer" }}
                            >
                              <Text strong>Credit Facility Type Breakdown</Text>
                            </div>
                          }
                        >
                          {item.Breakdown.map((b, bi) => (
                            <div key={bi} className="stats" style={{ marginBottom: bi === item.Breakdown.length - 1 ? 0 : 12 }}>
                              <div style={{ gridColumn: "1 / -1" }}>
                                <Text strong>{b.LoanProgrameTypeName ? (b.CreditFacilityName ? `${b.LoanProgrameTypeName} (${b.CreditFacilityName})` : b.LoanProgrameTypeName) : "N/A"}</Text>
                              </div>
                              <div>
                                <span className="stats-label">Total Limit</span>
                                <span className="stats-value">${`${_commonService.formatNumberWithCommas(b.TotalProgrameSize) || "N/A"}`}</span>
                              </div>
                              <div>
                                <span className="stats-label">Utilized</span>
                                <span className="stats-value">${`${_commonService.formatNumberWithCommas(b.Utilized) || "N/A"}`}</span>
                              </div>
                              <div>
                                <span className="stats-label">Remaining</span>
                                <span className="stats-value">${`${_commonService.formatNumberWithCommas(b.Remaining) || "N/A"}`}</span>
                              </div>
                              {/* <div>
                                <span className="stats-label">Active Loans</span>
                                <span className="stats-value">{`${_commonService.formatNumberWithCommas(b.Inprogressed) || "N/A"}`}</span>
                              </div> */}
                            </div>
                          ))}
                        </Panel>
                      </Collapse>
                    )}

                    {/* BUTTON */}
                    {/* <ButtonComponent
                    block
                    className="view-btn"
                    onClick={() =>
                      history.push({
                        pathname: routes.addEditSponsers.path,
                        state: { sponserId: item.Id },
                      })
                    }
                  >
                    View Details <RightOutlined />
                  </ButtonComponent> */}
                    <ButtonComponent
                      block
                      className="view-btn w100"

                      text="View Details"
                      icon={<RightOutlined />}
                      onClick={() => onViewDetailsClick(item)}
                    />

                  </Card>
                </Col>
              );
            })}
          </Row>

          {!loading && sponserData.length === 0 && (
            <Empty description="No Active Credit Facilities Created Yet" />
          )}



          <div className="sponsors-pagination-wrapper">
            <span className="pagination-total-text">
              Total {totalCount} Credit Facilitie{totalCount !== 1 ? "s" : ""}
            </span>
            <Pagination
              current={pageIndex}
              pageSize={pageSize}
              total={totalCount || sponserData.length}
              onChange={handlePageChange}
              onShowSizeChange={handlePageChange}
              showSizeChanger
              pageSizeOptions={["10", "20", "50", "100"]}
            />
          </div>
        </div>
      </SidebarLayout>
    </Spin>
  );
};

export default Sponsors;
